export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1280,
    stickyFooter: 1284,
    loadingOverlay: 1285,
    menu: 1290,
    drawer: 2005,
    modal: 1300,
    tabGroup: 400,
    toaster: 2010,
    header: 1100,
};
